import { useClient } from '@composables/use-clients';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export const apiFetchSkillActions = async ({
  domain = useTenantStore().domain,
  query = {},
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.skillActions({ domain }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
